<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import useSections from "@/scripts/Utilities/Sections.js";
import SelectCourse from "@/components/Dashboard/Utilities/Config/SelectCourse.vue";
import FileInput from "@/components/Dashboard/Utilities/MapFlags/FileInput.vue";
import SectionsTable from "@/components/Dashboard/Utilities/Sections/SectionsTable.vue";

const {
  course,
  file,
  loading,
  loadingSections,
  isFormValid,
  uploadSections,
  openSectionsModal,
  openSectionsTableModal,
} = useSections();
</script>

<template>
  <ContentHeader name="Sections Upload" :middleDots="true" />
  <section class="content">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <div class="form-group">
            <div class="ml-2"><SelectCourse v-model="course" /></div>
            <FileInput
              v-model="file"
              :accept="'.kml'"
              :label="'CHOOSE FILE'"
            /><br />

            <div class="input-group input-group-md">
              <button
                @click="uploadSections"
                type="button"
                class="btn m-1 btn-info tm-btn-red fixed-width-button"
                :disabled="!isFormValid || loading"
              >
                <font-awesome-icon
                  v-show="loading"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!loading">UPLOAD SECTIONS</span>
              </button>
              <button
                @click="openSectionsTableModal"
                type="button"
                class="btn m-1 btn-info tm-btn-red fixed-width-button"
                :disabled="!course"
              >
                <font-awesome-icon
                  v-show="loadingSections"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!loadingSections">VIEW SECTIONS</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <SectionsTable :loading="loadingSections" v-model="openSectionsModal" />
    </div>
  </section>
</template>

<style scoped>
.fixed-width-button {
  width: 180px;
}
</style>
